import React from 'react';
import Icon from '@ant-design/icons';
import { DataType } from '@kemu-io/hs-types';
import {
  GateUI,
	GateUIProps,
  GetPortsInformationFunction
} from '../index.js';
import styles from './OutputWidget.module.css';
import GateIcon from '@components/gateIcon/gateIcon';
import { ReactComponent as OutputWidgetIcon } from '@src/assets/img/gates/output-widget.svg';


type Props = GateUIProps


const OutputWidget = (props: Props) => {

  return (
    <div className={styles.OutputWrapper}>
			<Icon component={OutputWidgetIcon} />
    </div>
  );
};

/** Icon to be added to the bar */
const GateBarIcon = (): React.JSX.Element => {
	return (
		<GateIcon icon={<Icon component={OutputWidgetIcon} />}/>
	);
};


const getPortsInformation: GetPortsInformationFunction = (state, widgetInfo) => {

	return {
		inputs: [{
			name: 'event',
			type: DataType.Anything,
			position: 'Left',
		}],
		outputs: [],
	};
};

export default {
	getPortsInformation,
  hasTitle: false,

	BarIcon: GateBarIcon,
	Element: OutputWidget,
	getGatesBarTitle: (intl) => intl.formatMessage({ id: 'Widget.Output.Title' }),
} as GateUI;
